import _ from "underscore";
import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import IconClass from "../elements/icon";

const { any, string, func, bool } = PropTypes;
const Icon = React.createFactory(IconClass);

export default class extends React.Component {
  static displayName = "SearchBox";

  static propTypes = {
    name: string,
    placeholder: string,
    defaultValue: any,
    hideSearchIcon: bool,
    onKeyUp: func,
    onChange: func,
    onFocus: func,
    onBlur: func,
    focusOnMount: bool,
  };

  state = { focus: false, has_value: false };
  searchbox = null;

  componentDidMount() {
    this.mounted = true;
    if (this.props.defaultValue || this.searchbox.value) {
      this.setState({ has_value: true });
    }
    if (this.props.focusOnMount) {
      this.focus();
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  componentWillReceiveProps(nextProps) {
    const node = this.searchbox;
    if (
      !(node != null ? node.value : undefined) &&
      nextProps.defaultValue != null &&
      nextProps.defaultValue !== this.props.defaultValue
    ) {
      if (nextProps.defaultValue) {
        this.setState({ has_value: true });
      }
      return (node.value = nextProps.defaultValue);
    }
  }

  focus = () => {
    return this.searchbox != null ? this.searchbox.focus() : undefined;
  };

  handleUpdateHasValue = () => {
    if (this.mounted) {
      return this.setState({ has_value: !!this.searchbox.value });
    }
  };

  handleClear = e => {
    const node = this.searchbox;
    node.value = "";
    this.handleUpdateHasValue();
    if (e) {
      this.handleKeyUp(e);
      return this.handleChange(e);
    }
  };

  handleKeyUp = e => {
    e.stopPropagation();
    this.handleUpdateHasValue();
    return typeof this.props.onKeyUp === "function" ? this.props.onKeyUp(this.searchbox.value, e) : undefined;
  };

  handleChange = e => {
    e.stopPropagation();
    this.handleUpdateHasValue();
    return typeof this.props.onChange === "function" ? this.props.onChange(this.searchbox.value, e) : undefined;
  };

  render() {
    const base_props = {
      className: classNames("et--search-box", this.props.className),
    };
    const safe_props = _.omit(this.props, ["className", "focusOnMount"]);
    const attrs = _.extend({}, base_props, safe_props);

    return (
      <span {...attrs}>
        {Icon({
          icon: "search",
          className: "et--search-box--search-icon",
        })}
        {this.state.has_value ? (
          <a href="#" onClick={this.handleClear}>
            {Icon({ className: "et--search-box--clear", icon: "cancel" })}
          </a>
        ) : (
          undefined
        )}
        <input
          type="search"
          ref={e => {
            this.searchbox = e;
          }}
          data-testid="search-box"
          className="et--search-box--input"
          name={this.props.name}
          defaultValue={this.props.defaultValue}
          placeholder={this.props.placeholder}
          onFocus={this.props.onFocus}
          onBlur={this.props.onBlur}
          onKeyUp={this.handleKeyUp}
          onChange={this.handleChange}
        />
      </span>
    );
  }
}
